/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { resetFilters, setFilter, setPagination } from "..";

type FilterKeys =
  | "regional_email"
  | "regional_id"
  | "store_code"
  | "created_at_start"
  | "created_at_end"
  | "search"
  | "meta";

export const useFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter = (key: FilterKeys, value: any) => {
    dispatch(setFilter({ key, value }));
  };

  const clearFilters = () => {
    dispatch(resetFilters());
  };

  const updatePagination = (page: number, perPage: number) => {
    dispatch(setPagination({ page, perPage }));
  };

  return { updateFilter, clearFilters, updatePagination };
};
